import { snakeCase } from 'lodash';
export var ProjectEvents = /*#__PURE__*/ function(ProjectEvents) {
    ProjectEvents["ProjectCreate"] = "project_create";
    ProjectEvents["ProjectUpdate"] = "project_update";
    return ProjectEvents;
}({});
export const ProjectEventsMap = Object.keys(ProjectEvents).reduce((acc, key)=>{
    acc[snakeCase(key).toUpperCase()] = ProjectEvents[key];
    return acc;
}, {});
